"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.businessData = businessData;
exports.chartBuyApi = chartBuyApi;
exports.chartOrder30Api = chartOrder30Api;
exports.chartOrderMonthApi = chartOrderMonthApi;
exports.chartOrderWeekApi = chartOrderWeekApi;
exports.chartOrderYearApi = chartOrderYearApi;
exports.chartUserApi = chartUserApi;
exports.companyAutoListByTypetApi = companyAutoListByTypetApi;
exports.customersListApi = customersListApi;
exports.exportFudouUsageDetail = exportFudouUsageDetail;
exports.fileImageApi = fileImageApi;
exports.fucardIntegralData = fucardIntegralData;
exports.fucardIntegralSelect = fucardIntegralSelect;
exports.fucardUsedData = fucardUsedData;
exports.offsetOrderList = offsetOrderList;
exports.offsetOrderListIndex = offsetOrderListIndex;
exports.offsetOrderListMonth = offsetOrderListMonth;
exports.offsetOrderListWeek = offsetOrderListWeek;
exports.offsetOrderListYear = offsetOrderListYear;
exports.productConfigList = productConfigList;
exports.productConfigSave = productConfigSave;
exports.productStatus = productStatus;
exports.productUpdate = productUpdate;
exports.serviceCancelDispose = serviceCancelDispose;
exports.serviceCancelGetDisposeInfo = serviceCancelGetDisposeInfo;
exports.serviceCancelUpdateDispose = serviceCancelUpdateDispose;
exports.serviceCancelUploadDisposee = serviceCancelUploadDisposee;
exports.serviceInfo = serviceInfo;
exports.serviceLogInfo = serviceLogInfo;
exports.serviceLogList = serviceLogList;
exports.serviceProductList = serviceProductList;
exports.viewModelApi = viewModelApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 首页数据概览
function viewModelApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/index',
    method: 'GET'
  });
}

// 用户曲线图
function chartUserApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/user',
    method: 'get'
  });
}

// 用户购买统计
function chartBuyApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/user/buy',
    method: 'get'
  });
}

// 订单量趋势 30天
function chartOrder30Api() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order',
    method: 'get'
  });
}

// 订单量趋势 月
function chartOrderMonthApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/month',
    method: 'get'
  });
}

// 订单量趋势 周
function chartOrderWeekApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/week',
    method: 'get'
  });
}

// 订单量趋势 年
function chartOrderYearApi() {
  return (0, _request.default)({
    url: '/admin/statistics/home/chart/order/year',
    method: 'get'
  });
}

// 首页经营数据
function businessData() {
  return (0, _request.default)({
    url: '/admin/statistics/home/operating/data',
    method: 'get'
  });
}

// 30天订单量趋势
function offsetOrderList(params) {
  return (0, _request.default)({
    url: '/admin/offline/chart/order',
    method: 'get',
    params: params
  });
}

// 月订单量趋势
function offsetOrderListMonth(params) {
  return (0, _request.default)({
    url: '/admin/offline/chart/order/month',
    method: 'get',
    params: params
  });
}

// 周订单量趋势
function offsetOrderListWeek(params) {
  return (0, _request.default)({
    url: '/admin/offline/chart/order/week',
    method: 'get',
    params: params
  });
}

// 周订单量趋势
function offsetOrderListYear(params) {
  return (0, _request.default)({
    url: '/admin/offline/chart/order/year',
    method: 'get',
    params: params
  });
}

// 核销首页
function offsetOrderListIndex(params) {
  return (0, _request.default)({
    url: '/admin/offline/index',
    method: 'get',
    params: params
  });
}

// 线上暂不需要“福豆使用详细分布”接口预生产在使用，保留原定义便于后续恢复
function fucardUsedData(params) {
  return (0, _request.default)({
    url: '/admin/statistics/home/fucard/used/data',
    method: 'get',
    params: params
  });
}

// 三家通分页列表
function serviceProductList(params) {
  return (0, _request.default)({
    url: '/admin/service/product/list',
    method: 'get',
    params: params
  });
}
function fucardIntegralData(params) {
  return (0, _request.default)({
    url: '/admin/statistics/home/fudou/integral/data',
    method: 'get',
    params: params
  });
}

// 导出福豆使用明细
function exportFudouUsageDetail(params) {
  return (0, _request.default)({
    url: '/admin/statistics/home/fudou/integral/data/export',
    method: 'get',
    params: params
  });
}

// 项目下拉选择
function fucardIntegralSelect(params) {
  return (0, _request.default)({
    url: '/admin/fudou/project/select',
    method: 'get',
    params: params
  });
}

/**
 * 查询客户下拉列表
 * @param {*} id
 * @returns
 */
function customersListApi(params) {
  return (0, _request.default)({
    url: "/admin/customers/options",
    method: 'GET',
    params: params
  });
}

/**
 * 图片上传
 * @param data
 */
function fileImageApi(data, params) {
  return (0, _request.default)({
    url: '/admin/upload/image',
    method: 'POST',
    params: params,
    data: data
  });
}

/**
 * 商家列表自动补全
 */
function companyAutoListByTypetApi(params) {
  // return request({
  //     url: `/admin/business/supplier/autoListByType`,
  //     method: 'GET',
  //     params,
  // })

  return (0, _requestMapi.default)({
    url: "/mapi/user/supplier/autoListByType",
    method: 'GET',
    params: params
  });
}

/**
 * 服务配置列表
 */
function productConfigList(params) {
  return (0, _request.default)({
    url: "/admin/service/product/config/list",
    method: 'GET',
    params: params
  });
}

/**
 * 新增
 */
function productConfigSave(data) {
  return (0, _request.default)({
    url: "/admin/service/product/save",
    method: 'POST',
    data: data
  });
}

/**
 * 修改状态
 */
function productStatus(params) {
  return (0, _request.default)({
    url: "/admin/service/product/update/status",
    method: 'POST',
    params: params
  });
}

/**
 * 修改
 */
function productUpdate(data) {
  return (0, _request.default)({
    url: "/admin/service/product/update",
    method: 'POST',
    data: data
  });
}

/**
 * 详情
 */
function serviceInfo(params) {
  return (0, _request.default)({
    url: "/admin/service/product/info",
    method: 'GET',
    params: params
  });
}

/**
 * 查询服务日志
 */
function serviceLogList(data) {
  return (0, _request.default)({
    url: "/admin/sjt/service/log/list",
    method: 'POST',
    data: data
  });
}

/**
 * 查询服务日志详情
 */
function serviceLogInfo(params) {
  return (0, _request.default)({
    url: "/admin/sjt/service/log/info",
    method: 'GET',
    params: params
  });
}

/**
 * 查询服务取消愉悦
 */
function serviceCancelDispose(data) {
  return (0, _request.default)({
    url: "/admin/sjt/service/log/cancelDispose",
    method: 'POST',
    data: data
  });
}

/**
 * 修改处理结果
 */
function serviceCancelUpdateDispose(data) {
  return (0, _request.default)({
    url: "/admin/sjt/service/log/updateDispose",
    method: 'POST',
    data: data
  });
}

/**
 * 上传处理结果
 */
function serviceCancelUploadDisposee(data) {
  return (0, _request.default)({
    url: "/admin/sjt/service/log/uploadDispose",
    method: 'POST',
    data: data
  });
}

/**
 * 回显处理结果
 */
function serviceCancelGetDisposeInfo(logId) {
  return (0, _request.default)({
    url: "/admin/sjt/service/log/getDisposeInfo?logId=".concat(logId),
    method: 'GET'
  });
}